<template>
  <div class="scroll-graph__container">
    <img src="@/assets/img/scrollgraph/swipe.svg" alt class="scroll-marker">
    <div class="scroll-graph__content">
      <div :class="['graph--image', 'full-graph', 'scroll-graph', 'scroll-graph_' + patient]">
        <div class="scroll-graph-head" v-if="isHead">
          <p class="sg_head-text" v-html="text"></p>
        </div>
        <div class="scroll-graphs-block">
          <div class="graphs-block__left" :style="bgGraph"></div>
          <div class="graphs-block__right" :style="rightClasses">
            <img alt="" :style="rightClassesImg" :src="this.animationsData[this.srcID]['0'].src" class="graphs-block__right-img">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ScrollGraph',
  data() {
    return {};
  },
  props: {
    srcID: {
      type: Number
    },
    patient: {
      type: String
    },
    isHead: {
      type: Boolean,
      default: false
    },
    text: {
      type: String
    },
    left: {
      type: Number,
      default: 7.9
    }
  },
  computed: {
    ...mapState(['userAgent', 'animationsData']),
    bgGraph() {
      return {
        backgroundImage: 'url(\'' + this.animationsData[this.srcID]['0'].src + '\')',
        width: this.left + 'vh'
      }
    },
    rightClasses() {
      return {
        left: this.left + 'vh',
        width: 'calc(100% - ' + this.left + 'vh' + ')',
      }
    },
    rightClassesImg() {
      return {
        marginLeft: '-' + this.left + 'vh'
      }
    }
  }
};
</script>

<style lang="scss">
.scroll-graph__container {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: auto;
  position: relative;
  margin-top: 10px;
}

.scroll-graph__content {
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow-x: hidden;
}

.scroll-graph {
  display: block;
  width: 100%;
  height: auto;
  padding-top: 50px;
}

.scroll-marker {
  display: flex;
  top: 0;
  right: 0;
  position: absolute;
  color: #00998f;
  width: 34px;
  height: 35px;
}

.scroll-graphs-block {
  display: flex;
  position: relative;
  height: 45vh;
  max-height: 450px;
  overflow: hidden;
  background-color: #f6f5f6;

  .graphs-block__left {
    overflow: hidden;
    z-index: 5;
    background-position: top left;
    background-size: cover;
    background-repeat: no-repeat;
    //width: 7.9vh;
  }

  .graphs-block__right {
    position: absolute;
    //width: calc(100% - 7.9vh);
    //left: 7.9vh;
    right: 0;
    top: 0;
    bottom: 0;
    padding-bottom: 20px;
    box-sizing: content-box;
    height: 100%;
    overflow-x: overlay;
    overflow-y: hidden;
    z-index: 1;
    background-position: top left;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .graphs-block__right-img {
    height: 100%;
    width: auto;
    max-width: 5000px;
    //margin-left: -7.9vh;
  }
}

.scroll-graph-head {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #4e577f;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  padding: 10px 20px;
  @include media("<phone") {
    padding: 10px;
  }

  .sg_head-text {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.88;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
  }
}
</style>
